<template>
    <d-list-group flush>
      <d-list-group-item class="p-0">
        <d-form @submit.prevent="submit()">
          <d-form-row>

            <!-- Tempo de Garantia Default -->
            <d-col md="3" class="form-group">
              <label for="feWarrantyDefault">Tempo de Garantia Padrão</label>
              <d-form-input id="feWarrantyDefault" v-model="model.warranty" placeholder="Ano, mês, dias"/>
            </d-col>

            <!-- Validade do orçamento -->
            <d-col md="3" class="form-group">
              <label for="fedurationQuotation">Validade do orçamento</label>
              <d-form-input type="number" id="fedurationQuotation" placeholder="Tempo em dias" v-model="model.durationQuotation"/>
            </d-col>

            <!-- Tempo Alerta -->
            <d-col md="3" class="form-group">
              <label for="feTempoAlerta">Tempo Alerta ao cliente</label>
              <d-form-input type="number" id="feTempoAlerta" placeholder="Tempo de espera em dias" v-model="model.timeAlert"/>
            </d-col>

            <d-col md="3" class="form-group">
              <label for="feTempoAlerta">Notificação de novo chamado</label>
              <d-select v-model="model.ticketNotification" value-field="id" text-field="name" :options="rolesList"/>
            </d-col>

          </d-form-row>

          <d-form-row>
            <!-- Taxa de juros -->
            <d-col md="3" class="form-group">
              <label for="feTax">Taxa de juros mensal à prazo</label>
              <d-input-group append="%">
                <d-form-input class="text-right" type="number" step="0.001" min="0.001" id="feTax" placeholder="Número em %" v-model="model.tax"/>
              </d-input-group>
            </d-col>
            <!-- Comissão -->
            <d-col md="3" class="form-group">
              <label for="feCommission">Comissão</label>
              <d-input-group append="%">
                <d-form-input class="text-right" type="number" step="0.1" id="feCommission" placeholder="Número em %" v-model="model.commission"/>
              </d-input-group>
            </d-col>

            <d-col md="3" class="form-group">
              <label for="feLogo">Logo</label>
              <div class="custom-file mb-3">
                <input type="file" class="custom-file-input" id="feLogo" ref="file" @change="choseFile()"/>
                <label class="custom-file-label" for="feLogo">{{ file.name }}</label>
              </div>
            </d-col>
          </d-form-row>

          <d-form-row>
            <d-button type="submit" class="btn-primary">Salvar</d-button>
          </d-form-row>
        </d-form>

      </d-list-group-item>
    </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import SettingsService from '_services/rest/modules/settings';
import {
  _LOAD_MODEL_SETTING_,
  SETTINGS,
  OPTION,
} from './SettingsModel';

export default {
  name: 'settings-form',
  components: {},
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
  },
  data() {
    return {
      file: { name: 'Escolha uma imagem...' },
      model: { ...SETTINGS },
    };
  },
  watch: {},
  methods: {
    ...mapActions([
      'getRoles',
      'activeAlert',
    ]),
    choseFile() {
      [this.file] = this.$refs.file.files;
      this.model.logo = this.file.name;
    },
    getOptions() {
      if (!this.$store.state.settings.roles) {
        this.getRoles();
      }
    },
    save() {
      SettingsService.saveOptions(this.model, 'settings')
        .then(() => this.activeAlert({ message: 'Variáveis salvas com sucesso', theme: 'success' }))
        .catch(error => {
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        })
        .finally(this.loading = false);
    },
    submit() {
      this.loading = true;
      const { settings } = this.$store.state.settings;
      if (this.file.name !== settings.logo) {
        return this.uploadLogoFile();
      }
      return this.save();
    },
    uploadLogoFile() {
      SettingsService.upload(this.file)
        .then(response => {
          this.model.logo = response.path;
          this.file.name = this.model.logo;
          this.save();
        });
    },
  },
  mounted() {
    this.getOptions();
    Events.$on(_LOAD_MODEL_SETTING_, newValue => {
      this.model = { ...SETTINGS, ...newValue };
      this.file.name = this.model.logo;
    });
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label {
  overflow: hidden;
  white-space: nowrap;
}
</style>
